/*
  確認ユーザ一覧検索用データストア
*/
const getDefaultState = () => {
    return {
      // 検索条件
      searchCondition: {},
    };
  };
  
  /**
   * ステート
   */
  const state = getDefaultState();
  
  /**
   * ゲッター
   */
  const getters = {
    getSearchCondition(state) {
      return state.searchCondition;
    },
  };
  /**
   * ミューテーション
   */
  const mutations = {
    searchCondition(state, status) {
      state.searchCondition = status;
    },
    /**
     * state初期化
     * @param {ストア}} state
     */
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  };
  
  /**
   * アクション
   */
  const actions = {
    setSearchCondition(context, info) {
      context.commit("searchCondition", info);
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };